import '../../styles/pages/team.scss'

const tabs = document.querySelectorAll('.team__promo-tab');
const promoData = document.querySelectorAll('.team__promo-data-wrapper');
const teamText = document.querySelectorAll('.team__content');
const employees = document.querySelectorAll('.team__employee-container');

tabs.forEach((item, i) => {
  item.addEventListener('click', () => {
    tabs.forEach(tab => {
      tab.classList.remove('team__promo-tab-active');
    });
    promoData.forEach(data => {
      data.classList.add('team-hidden');
    });
    teamText.forEach(text => {
      text.classList.add('team-hidden');
    });
    employees.forEach(text => {
      text.classList.add('team-hidden');
    });
    item.classList.add('team__promo-tab-active');
    promoData[i].classList.remove('team-hidden');
    teamText[i].classList.remove('team-hidden');
    employees[i].classList.remove('team-hidden');
  })
})